const EXTRA_AUDIENCE_Y_OFFSET = 0.5;

export const applyExtraAudienceYOffset = (index: number) =>
  index * EXTRA_AUDIENCE_Y_OFFSET;
